export default "__VITE_ASSET__uD$zjos9__"